import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { showMessage } from "components/Modal";
import { LoadingButton } from "@mui/lab";
import { addCardAction } from "redux/actions/cardActions";
import CloseIcon from "@mui/icons-material/Close";
import { EMAIL_REGEX } from "util/regex";
import { ADD_CARD_STARTED } from "redux/ActionTypes";

export const AddCard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [errors, setErrors] = useState({});
  const { rType } = useSelector((state) => ({ rType: state.card.rType }));
  const loading = rType === ADD_CARD_STARTED;
  const handleClose = () => {
    setShowConfirm(false);
  };

  const handleSubmit = () => {
    dispatch(
      addCardAction({
        email,
        onSuccess: () => {
          setShowConfirm(false);
          showMessage({
            status: "success",
            description:
              "Your virtual card has been created and sent to your email.",
            onSubmit: () => {
              navigate("/cards/virtual-cards");
            },
          });
        },
      })
    );
    // }
  };

  const renderDialogConfirm = (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={showConfirm}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Add Card
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Typography gutterBottom>
          Email:{" "}
          <Typography sx={{ fontWeight: 500, display: "inline-block" }}>
            {email}
          </Typography>{" "}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={handleClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          sx={{ boxShadow: "none" }}
          // onClick={handleClose}
          onClick={handleSubmit}
          loading={loading}
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );

  return (
    <Card>
      <CardHeader title="Add Card" />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4} xl={3}>
            <TextField
              label="Email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              fullWidth
              error={errors.email}
              helperText={errors.email}
              onFocus={() => setErrors({})}
            />
          </Grid>
        </Grid>
      </CardContent>
      <CardActions sx={{ justifyContent: "center" }}>
        <LoadingButton
          variant="contained"
          loading={loading}
          //onClick={handleSubmit}
          onClick={() => {
            if (!EMAIL_REGEX.test(email)) {
              setErrors({ email: "The email address you entered is invalid." });
              return;
            }
            setShowConfirm(true);
          }}
          disabled={!email}
        >
          Submit
        </LoadingButton>
      </CardActions>
      {renderDialogConfirm}
    </Card>
  );
};

export default AddCard;
